import React from 'react';
import { AGENTS } from '../agents.js';

// ActivityRow — pure presentational digest row, ported from the prototype.
// props: { item, onJumpToAsk }
//   item: { kind('ask'|'working'|'intercept'|'done'), agent, when, text, toAgent? }
export default function ActivityRow({ item, onJumpToAsk }) {
  const a = AGENTS[item.agent];
  const to = item.toAgent ? AGENTS[item.toAgent] : null;
  return (
    <div className={`activity-row ${item.kind === 'working' ? 'working' : ''}`}>
      <span className="a-when">{item.when}</span>
      <span className="a-text">
        <span className="em">{a ? a.name : item.agent}</span>
        {item.kind === 'intercept' && to && <> → <span className="em">{to.name}</span></>}
        {' '}
        {item.kind === 'ask' && onJumpToAsk
          ? <button type="button" className="activity-jump" onClick={() => onJumpToAsk(item.askId)}>{item.text}</button>
          : item.text}
      </span>
      {item.kind === 'working' ? <span className="pulse-dot" /> : <span />}
    </div>
  );
}
